
function Nazione(country) {
    this.country = country;

    //NazioneService.getNazioneByCode(country).done(function (data) {
    //    this.IsCee(data);
    //});

}

Nazione.prototype.IsCee = function () {
    switch (this.country) {
        case "AT":
        case "BE":
        case "BG":
        case "CY":
        case "CZ":
        case "DE":
        case "DK":
        case "EE":
        case "EL":
        case "ES":
        case "FI":
        case "FR":
        case "GB":
        case "HR":
        case "HU":
        case "IE":
        case "IT":
        case "LT":
        case "LU":
        case "LV":
        case "MC":
        case "MT":
        case "NL":
        case "PL":
        case "PT":
        case "RO":
        case "SE":
        case "SI":
        case "SK":
            return true;
        default:
            return false;
    }
}

Nazione.prototype.IvaLunghezze = function () {
    switch (this.country) {
        case "DK":
        case "FI":
        case "IE":
        case "LU":
        case "MT":
        case "SI":
        case "HU":
            return [10];
        case "CZ":
            return [10, 11, 12];
        case "PT":
        case "ES":
        case "EL":
        case "DE":
        case "EE":
        case "AT":
        case "BG":
        case "CY":
            return [11];
        case "LT":
            return [11, 14];
        case "BE":
        case "PL":
        case "SK":
            return [12];
        case "MC":
        case "HR":
        case "FR":
        case "IT":
        case "LV":
            return [13];
        case "NL":
        case "SE":
            return [14];
        case "RO":
            return [4, 5, 6, 7, 8, 9, 10, 11, 12];
        case "GB":
            return [7, 11, 14];
    }

    return [];

}

Nazione.prototype.IsoCode = function () {
    switch (this.country) {
        case "AT":
        case "BE":
        case "BG":
        case "CY":
        case "CZ":
        case "DE":
        case "DK":
        case "EE":
        case "EL":
        case "ES":
        case "FI":
        case "FR":
        case "GB":
        case "HR":
        case "HU":
        case "IE":
        case "IT":
        case "LT":
        case "LU":
        case "LV":
        case "MT":
        case "NL":
        case "PL":
        case "PT":
        case "RO":
        case "SE":
        case "SI":
        case "SK":
            return this.country;
        case "MC":
            return "FR";
    }

    return "";
}

Nazione.prototype = {
    IsCee: function () { },
    IvaLunghezze: function () { },

};

var NazioneService = (function ($) {

    var url = '', username = '';

    function getNazioniList() {
        $.ajax({

        });
    }


    function getNazioneByCode() {
        return $.ajax({

        });
    }


    return {
        getNazioniList: getNazioniList,
        getNazioneByCode: getNazioneByCode
    };

})(jQuery);

